import React from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import { formatDate, formatPrice } from './reservationUtils';

const ReservationSummary = ({ order, roomName, showConfirmationNumber = false, showTotalPrice = true }) => (
  <>
    <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
      Podsumowanie rezerwacji
    </Typography>
    <Paper variant="outlined" sx={{ p: 2, mb: 3, borderRadius: 2 }}>
      {showConfirmationNumber && (
        <>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            Numer potwierdzenia
          </Typography>
          <Typography variant="h6" fontWeight={500} sx={{ mb: 2 }}>
            {order?.confirmationNumber ?? order?.id ?? '—'}
          </Typography>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Zameldowanie</Typography>
          <Typography variant="body1" fontWeight={500}>{formatDate(order?.checkin)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Wymeldowanie</Typography>
          <Typography variant="body1" fontWeight={500}>{formatDate(order?.checkout)}</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Pokój</Typography>
          <Typography variant="body1" fontWeight={500}>
            {roomName ?? `Pokój nr ${order?.roomId ?? '—'}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary">Liczba gości</Typography>
          <Typography variant="body1" fontWeight={500}>{order?.adults ?? '—'}</Typography>
        </Grid>
        {showTotalPrice && (
          <Grid item xs={12}>
            <Typography variant="body2" color="text.secondary">Cena całkowita</Typography>
            <Typography variant="body1" fontWeight={600}>{formatPrice(order?.totalPrice)}</Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  </>
);

export default ReservationSummary;
